import { render, staticRenderFns } from "./PreviewInfo.vue?vue&type=template&id=1bd33cdf"
import script from "./PreviewInfo.vue?vue&type=script&lang=js"
export * from "./PreviewInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports